export const monthOptions = [
    {label: "Januari", value: 1},
    {label: "Februari", value: 2},
    {label: "Maret", value: 3},
    {label: "April", value: 4},
    {label: "Mei", value: 5},
    {label: "Juni", value: 6},
    {label: "Juli", value: 7},
    {label: "Agustus", value: 8},
    {label: "September", value: 9},
    {label: "Oktober", value: 10},
    {label: "November", value: 11},
    {label: "Desember", value: 12},
];

const currentYear = new Date().getFullYear();
export const yearOptions = Array.from({length: currentYear - 1990 + 1}, (_, i) => {
    const year = currentYear - i;
    return {
        label: String(year),
        value: year,
    };
});

export const configMonthToDate = [
    {name: "payment", label: "\n", options: {sort: false,}},
    {name: "lastMonth", label: "Last Month", options: {sort: false,}},
    {name: "thisMonth", label: "This Month", options: {sort: false,}},
    {name: "growth", label: "Growth", options: {sort: false,}},
    {name: "projection", label: "Proyeksi", options: {sort: false,}},
];

export const configYearToDate = [
    {name: "payment", label: "\n", options: {sort: false}},
    {name: 1, label: "JAN", options: {sort: false}},
    {name: 2, label: "FEB", options: {sort: false}},
    {name: 3, label: "MAR", options: {sort: false}},
    {name: 4, label: "APR", options: {sort: false}},
    {name: 5, label: "MAY", options: {sort: false}},
    {name: 6, label: "JUN", options: {sort: false}},
    {name: 7, label: "JUL", options: {sort: false}},
    {name: 8, label: "AUG", options: {sort: false}},
    {name: 9, label: "SEP", options: {sort: false}},
    {name: 10, label: "OCT", options: {sort: false}},
    {name: 11, label: "NOV", options: {sort: false}},
    {name: 12, label: "DEC", options: {sort: false}},
    {name: "yearToDate", label: "Year To Date (Tahun)", options: {sort: false}},
];

export const configLast3Years = [
    {name: "q1y2", label: "Q1 Y-2", options: {sort: false}},
    {name: "q2y2", label: "Q2 Y-2", options: {sort: false}},
    {name: "q3y2", label: "Q3 Y-2", options: {sort: false}},
    {name: "q4y2", label: "Q4 Y-2", options: {sort: false}},
    {name: "q1y1", label: "Q1 Y-1", options: {sort: false}},
    {name: "q2y1", label: "Q2 Y-1", options: {sort: false}},
    {name: "q3y1", label: "Q3 Y-1", options: {sort: false}},
    {name: "q4y1", label: "Q4 Y-1", options: {sort: false}},
    {name: "q1y", label: "Q1 Y", options: {sort: false}},
    {name: "q2y", label: "Q2 Y", options: {sort: false}},
    {name: "q3y", label: "Q3 Y", options: {sort: false}},
    {name: "q4y", label: "Q4 Y", options: {sort: false}},
];